import { t } from '@lingui/core/macro';

import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';

import OpportunitiesOverviewActions from './OpportunitiesOverviewActions';
import { OpportunitiesOverviewKPIMetrics } from './OpportunitiesOverviewKPIMetrics';
import OpportunitiesOverviewTableContainer from './OpportunitiesOverviewTableContainer';
import { OpportunitiesOverviewTrendBar } from './OpportunitiesOverviewTrendBar';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  sortBy: 'openDate',
  sortOrder: InstantSearchSortOrder.DESC,
};

const OpportunitiesOverview = () => {
  return (
    <Page title={t`Opportunities`} exampleAIQuestions={[]}>
      <PageFilterProvider>
        <InstantSearch prefix="o" defaultQueryState={DEFAULT_QUERY_STATE}>
          <div className="flex w-full flex-col gap-6">
            <div className="flex items-start justify-between">
              <PageDateRangeFilter />
              <OpportunitiesOverviewActions />
            </div>
            <OpportunitiesOverviewKPIMetrics />
            <OpportunitiesOverviewTrendBar />
            <OpportunitiesOverviewTableContainer />
          </div>
        </InstantSearch>
      </PageFilterProvider>
    </Page>
  );
};

export default OpportunitiesOverview;
